// ============================================================================
// LazyAdminAddReportModal — the Admin Add Report modal, loaded on first open
// ============================================================================
// A LOADING boundary and nothing else. The six daily hubs mount this exactly
// where they mounted the modal (their existing `showAddModal &&` condition), so
// the modal, its unfinished-draft adapter and its cattle/sheep readback load
// with the first Add Report click instead of in the startup chunk. Every draft,
// form, data, ownership and permission decision stays in AdminAddReportModal.
// ============================================================================
import React from 'react';
import type AdminAddReportModal from './AdminAddReportModal.tsx';
import type {AdminAddReportModalProps} from './AdminAddReportModal.tsx';

// Hoisted to the module, so the lazy component has ONE stable identity: a hub
// re-rendering never remounts the modal (and never resets its owner-keyed
// body). React.lazy erases the modal's generic <Row>; the assertion restores
// exactly the modal's own type, because this IS that component once loaded.
const LazyModal = React.lazy(() => import('./AdminAddReportModal.tsx')) as unknown as typeof AdminAddReportModal;

export default function LazyAdminAddReportModal<Row>(props: AdminAddReportModalProps<Row>) {
  // null while the chunk loads: the modal was not on screen a moment ago either.
  return (
    <React.Suspense fallback={null}>
      <LazyModal<Row> {...props} />
    </React.Suspense>
  );
}
